import { render, staticRenderFns } from "./dialogLotto.vue?vue&type=template&id=46991eaa"
import script from "./dialogLotto.vue?vue&type=script&lang=js"
export * from "./dialogLotto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports